import { render } from "./FullPreFooter.vue?vue&type=template&id=2b67c808&scoped=true"
import script from "./FullPreFooter.vue?vue&type=script&lang=js"
export * from "./FullPreFooter.vue?vue&type=script&lang=js"

import "./FullPreFooter.vue?vue&type=style&index=0&id=2b67c808&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b67c808"]])

export default __exports__